
import {defineComponent, getCurrentInstance, reactive, ref} from 'vue';
export const useSortDataVoucherReportData = () => {
  const {proxy} = getCurrentInstance();
  const columnC202a = reactive([
    {
      column_name: 'Mã NDKT',
      title: 'Mã nội dung kinh tế',
      dataField: 'budget_sub_item_code',
      sort_type: 2,
      sort_order: 1,
    },
    {
      dataField: 'budget_chapter_code',
      column_name: 'Mã Chương',
      sort_type: 2,
      sort_order: 2,
    },
    {
      column_name: 'Mã Ngành KT',
      title: 'Mã ngành kinh tế',
      dataField: 'budget_sub_kind_item_code',
      sort_type: 2,
      sort_order: 3,
    },
    {
      column_name: 'Mã Nguồn NSNN',
      title: 'Mã nguồn ngân sách nhà nước',
      dataField: 'budget_source_property_code',
      sort_type: 2,
      sort_order: 4,
    },
    {
      column_name: 'Thứ tự nhập liệu',
      title: 'Mã nguồn ngân sách nhà nước',
      dataField: 'sort_order',
      sort_type: 2,
      sort_order: 5,
    },
  ]);
  return {
    columnC202a
  }
}